const conversationStatusOptions = ['Active', 'Finished', 'Reviewed', 'Archived'];

const conversationTriggerOptions = [
    'NewUser',
    'UserStarted',
    'DataAnalysis',
    'IdleNewUser',
    'AdminMessage',
    'PublicVisitor',
    'Nudge',
];

const conversationFeedbackTypeOptions = [
    'Nudge',
    'Bug Report',
    'Feature Request',
    'Feedback',
    'Other',
];

// Mirrors API/Soapy/Assistant/Domain/AttentionStatus.php, keyed by the enum value, in the same order.
// That order runs most to least urgent, which is how the options are listed; nothing sorts or orders
// conversations by attention status.
// A status with a badgeTheme is rendered as a full badge rather than a bare icon, so it stands out.
const attentionStatuses = {
    'Priority': {
        name: 'Priority',
        icon: 'CircleExclamation',
        iconTheme: 'solid',
        className: 'fill-danger',
        badgeTheme: 'danger',
    },
    'Needs Attention': {
        name: 'Needs attention',
        icon: 'Bell',
        iconTheme: 'solid',
        className: 'fill-brand',
    },
    'Snoozed': {
        name: 'Snoozed',
        icon: 'AlarmSnooze',
        className: 'fill-muted',
    },
    'Waiting': {
        name: 'Waiting',
        icon: 'Clock',
        className: 'fill-muted',
    },
    'Muted': {
        name: 'Muted',
        icon: 'BellSlash',
        className: 'fill-muted',
    },
};

const conversationAttentionStatusOptions = Object.keys(attentionStatuses);

export {
    conversationStatusOptions,
    conversationTriggerOptions,
    conversationFeedbackTypeOptions,
    conversationAttentionStatusOptions,
    attentionStatuses,
};
